import type { DisplayQBankStructureLevelItem } from '../types';

export function findLevelItemParentById(
  items: DisplayQBankStructureLevelItem[],
  parentId: string,
): DisplayQBankStructureLevelItem | null {
  for (const item of items) {
    if (item.children) {
      const parent = findLevelItemParentById(item.children, parentId);
      if (parent) {
        return parent;
      }
    }

    if (item.id === parentId) {
      return item;
    }
  }

  return null;
}
